// src/pages/YouTube.js
import React from 'react';
import FeaturePageLayout from '../components/FeaturePageLayout';
import { 
    IoLogoYoutube,
    IoFilmOutline,
    IoChatbubblesOutline,
    IoAnalyticsOutline,
    IoRocketOutline
} from 'react-icons/io5';
import image1 from '../assets/images/Generate.png';
import image2 from '../assets/images/Schedule2.png';
import image3 from '../assets/images/Messages.png';
import image4 from '../assets/images/Analytics2.png';
import heroBg from '../assets/images/youtube-background.png';

const breadcrumbSchema = { "@context": "https://schema.org", "@type": "BreadcrumbList", "itemListElement": [{ "@type": "ListItem", "position": 1, "name": "Home", "item": "https://oolook.in/" }, { "@type": "ListItem", "position": 2, "name": "YouTube Management", "item": "https://oolook.in/youtube" }] };
const serviceSchema = { "@context": "https://schema.org", "@type": "Service", "serviceType": "YouTube Marketing Software", "provider": { "@type": "Organization", "name": "Oolook" }, "name": "AI YouTube Management & Optimization Tool", "description": "Grow your YouTube channel faster with Oolook. Use AI to generate video ideas, titles, and descriptions, schedule uploads, and analyze your performance.", "url": "https://oolook.in/youtube" };

const pageData = {
  seo: {
    title: "AI YouTube Management & Optimization Tool | Oolook",
    description: "Supercharge your YouTube workflow. Oolook's AI helps you brainstorm video ideas, write SEO-friendly titles and descriptions, schedule uploads, and track your channel's growth.",
    image: 'https://oolook.in/og/youtube.png',
    schemas: [breadcrumbSchema, serviceSchema]
  },
  hero: {
    icon: IoLogoYoutube,
    title: "Grow Your YouTube Channel, Smarter",
    subtitle: "From video ideas to performance analytics, Oolook is your AI-powered co-pilot for creating a successful YouTube channel and streamlining your workflow.",
    backgroundImage: heroBg
  },
  featureSection: {
    title: "A Complete Workflow for YouTube Creators",
    subtitle: "Optimize every aspect of your channel management, from pre-production to post-publication analysis.",
    features: [
      { title: "AI Video Idea & Script Generator", description: "Beat creative block by generating trending video ideas, outlines, and script hooks tailored to your niche.", image: image1 },
      { title: "Schedule Video Uploads", description: "Upload your videos and schedule them to go live at the perfect time. Oolook helps you plan your content calendar with ease.", image: image2 },
      { title: "Manage Your Community", description: "Keep track of all your video comments in our Unified Inbox. Respond faster and build a more engaged subscriber base.", image: image3 },
      { title: "In-Depth Channel Analytics", description: "Track key metrics like watch time, audience retention, and subscriber growth to understand what content performs best.", image: image4 }
    ]
  },
  benefitGrid: {
    title: "The Impact of an Optimized Channel",
    benefits: [
      { icon: IoFilmOutline, title: "Create Better Videos", description: "Use AI to brainstorm and script content that resonates with viewers and keeps them watching." },
      { icon: IoRocketOutline, title: "Boost Your Discovery", description: "Write SEO-friendly titles and descriptions that help your videos get discovered in search and recommendations." },
      { icon: IoChatbubblesOutline, title: "Build an Active Community", description: "Engage with your audience more effectively by managing all your comments in one place." },
      { icon: IoAnalyticsOutline, title: "Accelerate Your Growth", description: "Make data-driven decisions to improve your content strategy and grow your subscriber base faster." }
    ]
  },
  stepByStep: {
    title: "Streamline Your Path to YouTube Success",
    subtitle: "A simple, powerful workflow for managing your channel.",
    steps: [
      { title: "1. Connect Your YouTube Channel", description: "Securely link your channel to Oolook to sync your videos, comments, and analytics." },
      { title: "2. Generate Your Next Video Idea", description: "Use the AI generator with a simple prompt like 'brainstorm video ideas for a cooking channel' to get started." },
      { title: "3. Optimize & Schedule Your Upload", description: "Upload your finished video and let Oolook's AI help you write the perfect, SEO-friendly title and description before scheduling." },
      { title: "4. Engage and Analyze", description: "As comments roll in, manage them from the Unified Inbox. Track your video's performance in the analytics dashboard." }
    ]
  },
  targetAudience: {
    title: "The Essential Toolkit for Creators and Video Marketers"
  }
};

const YouTube = () => {
  return <FeaturePageLayout pageData={pageData} />;
};

export default YouTube;